<template>
  <div>
    <v-card 
      class="autoscroll mx-auto"
    >
      <v-toolbar>
        <img class="logo" src="../../assets/logo.png" />
        <div class="fullwidth">
          <div class="nametag">
            <span v-if="firstName" class="float-right ml-10">
              {{ firstName }} {{ lastName }}
            </span>
            <span v-if="firstName" class="float-right ml-10">
              {{ email }}
            </span>
          </div>
          <div>
            <v-avatar class="float-right" color="#65893b">
                <v-icon dark> mdi-account-circle </v-icon>
              </v-avatar>
            <v-dialog v-model="dialog" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="float-right mt-1" icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-help</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  Help Center
                </v-card-title>
                <v-card-text> </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="dialog = false"> OK </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </v-toolbar>

      <v-container>
        <v-form v-model="valid" lazy-validation ref="form">
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step
                :rules="basicRules"
                :complete="e1 > 1"
                step="1"
              >
                Model Information
              </v-stepper-step>
              <v-divider> </v-divider>

              <v-stepper-step
                :rules="uploadRules"
                :complete="e1 > 2"
                step="2"
              >
                Upload Files
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                :rules="userRules"
                :complete="e1 > 3"
                step="3"
              >
                Additional Users
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                step="4"
              > 
                Summary
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card 
                  class="mb-1" 
                  color="grey darken-1"
                >
                  <v-card-title class="text--primary">
                    Model Information
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="Model description"
                      v-model="applicationName"
                      hide-details="auto"
                      :rules="requiredRules"
                    ></v-text-field>

                    <v-combobox
                      multiple
                      v-model="entryFunctionNames"
                      label="Entry function name"
                      append-icon
                      chips
                      deletable-chips
                      :rules="requiredRules"
                    >
                    </v-combobox>

                    <v-select
                      v-model="language"
                      :items="items"
                      label="Language"
                    ></v-select>

                    <v-textarea
                      v-model="memo"
                      no-resize
                      clear-icon="mdi-close-circle"
                      label="Memo"
                    ></v-textarea>
                  </v-card-text>
                </v-card>

                <v-btn color="primary" @click="next">
                  Continue <v-icon right> mdi-chevron-double-right </v-icon>
                </v-btn>
                <ExitWizardButton @click="$emit('exit')" class="floatright">
                </ExitWizardButton>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card
                  class="mb-1" 
                  color="grey darken-1"
                >
                  <v-card-title class="text--primary">
                    Upload files
                  </v-card-title>
                  <v-card-text>
                    <CloseableChipFileInput
                      fileinputlabel="Local Model ZIP File"
                      v-model="localmodelFiles"
                    ></CloseableChipFileInput>
                    <v-progress-linear
                      v-show="localmodeluploadprogress"
                      color="light-blue"
                      indeterminate
                      striped
                      height="8"
                    ></v-progress-linear>
                     <CloseableChipFileInput
                      fileinputlabel="Source ZIP File"
                      v-model="sourceFiles"
                    ></CloseableChipFileInput>

                    <v-progress-linear
                      v-show="sourcecodeuploadprogress"
                      color="light-blue"
                      indeterminate
                      striped
                      height="8"
                    ></v-progress-linear>
                     <CloseableChipFileInput
                      fileinputlabel="Menu Definition ZIP File"
                      v-model="menuFiles"
                    ></CloseableChipFileInput>

                    <v-progress-linear
                      v-show="menuuploadprogress"
                      color="light-blue"
                      indeterminate
                      striped
                      height="8"
                    ></v-progress-linear>

                    <v-textarea
                      v-model="menuFileNote"
                      clearable
                      clear-icon="mdi-close-circle"
                      label="Menu File Note"
                    ></v-textarea>
                  </v-card-text>
                </v-card>
                <v-btn text @click="previous"> 
                  <v-icon left> mdi-chevron-double-left </v-icon> Back 
                </v-btn>
                <v-btn color="primary" @click="next">
                  Continue <v-icon right> mdi-chevron-double-right </v-icon>
                </v-btn>
                <ExitWizardButton @click="$emit('exit')" class="floatright">
                </ExitWizardButton>
                <v-row>
                  <v-dialog
                    v-model="submitProcessDialog"
                    persistent
                    width="500"
                  >
                    <v-card color="primary" dark>
                      <v-card-text>
                        Submitting data...
                        <v-progress-linear
                          indeterminate
                          color="white"
                          class="mb-0"
                        ></v-progress-linear>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-row>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-container fluid>
                  <v-row>
                    <v-col>
                      <v-card class="mb-12" color="grey darken-1">
                        <v-card-title class="text--primary">
                          Add Additional Users
                        </v-card-title>
                    
                        <v-form
                          ref="form"
                          v-model="form1"
                          lazy validation
                        >
                          <v-container>
                            <v-row v-for="(user,index) in users" v-bind:key="index">
                              <v-col
                                cols="12"
                                md="3"
                                sm="6"
                              >
                                <v-text-field
                                  v-model="users[index].firstName"
                                  label="First name"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="3"
                                sm="6"
                              >
                                <v-text-field
                                  v-model="users[index].lastName"
                                  label="Last name"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="4"
                                sm="6"
                              >
                                <v-text-field
                                  v-model="users[index].email"
                                  :rules='emailvalidation(users[index].firstName, users[index].lastName)'
                                  label="E-mail"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="1"
                                md="1"
                                sm="6"
                              >
                                <v-btn
                                  color="primary"
                                  @click="addMoreUser"
                                >
                                  <v-icon dark>
                                    mdi-plus
                                  </v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
                <v-btn text @click="previous"> 
                  <v-icon left> mdi-chevron-double-left </v-icon> Back 
                </v-btn>
                <v-btn color="primary" @click="next">
                  Continue <v-icon right> mdi-chevron-double-right </v-icon>
                </v-btn>
                <ExitWizardButton @click="$emit('exit')" class="floatright">
                </ExitWizardButton>
                </v-stepper-content>
                <v-stepper-content step="4">
                  <v-card elevation="2" class="mb-1" color="grey darken-1">
                    <v-card-title class="text--primary">
                      Summary
                    </v-card-title>
                    <v-card-text>
                      <fieldset class="rounded">
                        <legend class="rounded">Model Information</legend>
                         <EditButton
                            @step="e1 = 1"
                            class="editbtn"
                          ></EditButton>
                        <SummaryGrid
                          labelText="Model description:"
                          :textfield="applicationName"
                          class="mx-2"
                        >
                        </SummaryGrid>
                        <SummaryGrid
                          labelText="Language:"
                          :textfield="language"
                          class="mx-2"
                        >
                        </SummaryGrid>
                        <SummaryGrid
                          labelText="Memo:"
                          :textfield="memo"
                          class="mx-2"
                        >
                        </SummaryGrid>
                      </fieldset>
                      <fieldset class="mt-5 rounded">
                        <legend class="rounded">Upload Files</legend>
                        <EditButton
                          @step="e1 = 2"
                          class="editbtn"
                        ></EditButton>
                        <SummaryGrid
                          labelText="Local model zip file:"
                          :list="localmodelFiles"
                          class="mx-2"
                        >
                        </SummaryGrid>
                        <SummaryGrid
                          labelText="Source zip file:"
                          :list="sourceFiles"
                          class="mx-2"
                        >
                        </SummaryGrid>
                        <SummaryGrid
                          labelText="Menu definition file:"
                          :list="menuFiles"
                          class="mx-2"
                        >
                        </SummaryGrid>
                        <SummaryGrid
                          labelText="Menu file note:"
                          :textfield="menuFileNote"
                          class="mx-2"
                        >
                        </SummaryGrid>
                      </fieldset>
                      <fieldset class="mt-5 rounded">
                        <legend class="rounded">Additional Users</legend>
                        <EditButton
                          @step="e3 = 3"
                          class="editbtn"
                        ></EditButton>
                        <v-row class="mx-2">
                          <v-col cols="12" sm="2">
                              <div class="text-left">
                                  <span> Additional users: </span>
                              </div>                        
                          </v-col>
                          <v-col cols="12" sm="8">
                              <div class="text-left">
                                <v-simple-table v-if="users.length > 0">
                                  <template v-slot:default>
                                    <thead>
                                      <tr>
                                        <th class="text-left">
                                          First name
                                        </th>
                                        <th class="text-left">
                                          Last name
                                        </th>
                                        <th class="text-left">
                                          Email
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="{firstName, lastName, email} in users"
                                        :key="email"
                                      >
                                        <td>{{ firstName }}</td>
                                        <td>{{ lastName }}</td>
                                        <td>{{ email }}</td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </div>
                          </v-col>
                        </v-row>
                      </fieldset>
                    </v-card-text>
                  </v-card>
                  <v-btn text @click="previous"> 
                    <v-icon left> mdi-chevron-double-left </v-icon>Back 
                  </v-btn>
                  <v-btn
                    color="primary"
                    type="submit"
                    @click="handleSubmit"
                    :disabled="!valid"
                  >
                    Submit
                    <v-icon right> mdi-cloud-upload </v-icon>
                  </v-btn>
                  <ExitWizardButton @click="$emit('exit')" class="floatright">
                  </ExitWizardButton>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-form>
      </v-container>
    </v-card>

    <v-alert
      :value="ticketcreatesuccess"
      type="success"
      style="bottom: 25px; left: 0px; right: 0px; position: absolute"
    >
      Submit data successfully.
    </v-alert>

    <v-alert
      :value="ticketcreateerror"
      type="error"
      style="bottom: 25px; left: 0px; right: 0px; position: absolute"
    >
      Submit data unsuccessfully.
    </v-alert>

    <v-footer absolute class="footer">
      <v-spacer></v-spacer>
      <div>&copy; {{ new Date().getFullYear() }} CM First Group</div>
    </v-footer>
  </div>
</template>

<style scoped>
.theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: rgb(30,30,30) !important;
}
</style>

<script>
import Welcome from "@/components/Welcome.vue"
import SummaryGrid from '../customwidgets/SummaryGrid'
import EditButton from '../customwidgets/EditButton'
import CloseableChipFileInput from '../customwidgets/CloseableChipFileInput'
import ExitWizardButton from '../customwidgets/ExitWizardButton'
import axios from "axios"

export default {
  name: "Upload",
  props: ["firstName", "lastName", "email"],
  components: {
    Welcome,
    SummaryGrid,
    EditButton,
    CloseableChipFileInput,
    ExitWizardButton
  },
  data: function () {
    return {
      items: ['English', 'French', 'German', 'Spanish'],
      ticketcreatesuccess: false,
      dialog: false,
      valid: true,
      ticketcreateerror: false,
      localmodeluploadprogress: false,
      submitProcessDialog: false,
      sourcecodeuploadprogress: false,
      menuuploadprogress: false,
      localmodelFiles: [],
      sourceFiles: [],
      menuFiles: [],
      LocalModelZIPURL: "",
      SourceZIPURL: "",
      MenuInforFileURL: "",
      entryFunctionNames: [],
      memo: "",
      applicationName: "",
      menuFileNote: "",
      language: "English",
      e1: 1,
      users: [
        {
          firstName: "",
          lastName: "",
          email: "",
        },
      ],
      requiredRules: [
        (value) => {
          if (value instanceof Array && value.length == 0) {
            return "This field is required.";
          }

          return !!value || "This field is required.";
        },
      ],
      emailRequiredRules: [
        (value) => !!value || "This field is required.",
        (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      ],
      basicRules: [
        () => {
          if (!this.valid) {
            if (!this.ApplicationName || this.EntryFunctionNames.length == 0) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        },
      ],
      uploadRules: [
        () => {
          return true;
        },
      ],
      userRules: [
        () => {
          return this.valid;
        },
      ],
    };
  },
  methods: {
    emailvalidation(firstname, lastname) {
        return [
          (value) => {
            if(firstname != "" && lastname != "" && !value){
              return 'Required.'
            }
          },
          (value) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
        ]
    },
    uploadFileViaNodeServer: async function (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);

      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      var data = await axios.post(
        process.env.ROOT_API + "/upload",
        formData,
        config
      );

      return data.data;
    },

    processUploadLocalModel: async function (files) {
      if (files && files.length > 0) {
        this.localmodeluploadprogress = true;
        var result = await this.uploadFileViaNodeServer(files[0]);
        this.localmodeluploadprogress = false;
        if (result) {
          this.LocalModelZIPURL = result;
        }
      } else {
        this.LocalModelZIPURL = "";
      }
    },

    processUploadSourceCode: async function (files) {
      if (files && files.length > 0) {
        this.sourcecodeuploadprogress = true;
        var result = await this.uploadFileViaNodeServer(files[0]);
        this.sourcecodeuploadprogress = false;

        if (result) {
          this.SourceZIPURL = result;
        }
      } else {
        this.SourceZIPURL = "";
      }
    },

    processUploadMenuOutput: async function (files) {
      if (files && files.length > 0) {
        this.menuuploadprogress = true;
        var result = await this.uploadFileViaNodeServer(files[0]);
        this.menusuccess = true;
        this.menuuploadprogress = false;

        if (result) {
          this.MenuInforFileURL = result;
        }
      } else {
        this.MenuInforFileURL = "";
      }
    },
    next () {
      if(this.$refs.form.validate()){
        this.e1++;
      }
    },
    previous () {
      this.e1--
    },
    handleSubmit: async function (e) {
      var current = this;
      e.preventDefault();
      this.$refs.form.validate();
       current.submitProcessDialog = true;
      await this.processUploadLocalModel(this.localmodelFiles);
      await this.processUploadSourceCode(this.sourceFiles);
      await this.processUploadMenuOutput(this.menuFiles);
      setTimeout(async function () {
        if (current.valid) {
          let success = await current.buildURL(
            current.entryFunctionNames,
            current.memo,
            current.LocalModelZIPURL,
            current.SourceZIPURL,
            current.MenuInforFileURL,
            current.applicationName,
            current.menuFileNote,
            current.language,
            current.users
          );
          if (success) {
            current.ticketcreatesuccess = true;
            current.e1 = 1;
            current.$refs.form.reset();
            current.submitProcessDialog = false;

            setTimeout(function () {
              current.ticketcreatesuccess = false;
            }, 3000);
          } else {
            this.ticketcreateerror = true;
            current.submitProcessDialog = false;
            setTimeout(function () {
              current.ticketcreateerror = false;
            }, 3000);
          }
        }
      }, 0);
    },

    buildURL: async function (
      EntryFunctionNames,
      Memo,
      LocalModelZIPURL,
      SourceZIPURL,
      MenuInforFileURL,
      ApplicationName,
      MenuFileNote,
      Language,
      Users
    ) {
      let config = {
        headers: {
          "content-type": "application/json",
        },
      };

      try {
        var uploadedFiles = {};

        if (LocalModelZIPURL) {
          uploadedFiles.PlexModel = [{"URL" : LocalModelZIPURL,"Memo" : "","Downloaded" : false,"IsValid" : false}];
        }

        if (SourceZIPURL) {
          uploadedFiles.PlexSrc = [{"URL" : SourceZIPURL,"Memo" : "","Downloaded" : false,"IsValid" : false}];
        }

        if (MenuInforFileURL) {
          uploadedFiles.PlexMenu = [{"URL" : MenuInforFileURL,"Memo" : MenuFileNote,"Downloaded" : false,"IsValid" : false}];
        }

        let inputData = {
          TargetModel: "Plex",
          CompanyName: "",
          RequestorFirstName: this.firstName,
          RequestorLastName: this.lastName,
          RequestorEmail: this.email,
          ApplicationName: ApplicationName,
          UploadedFiles: uploadedFiles,
          // LocalModelZIPURL: LocalModelZIPURL,
          // SourceZIPURL: SourceZIPURL,
          // MenuInforFileURL: MenuInforFileURL,
          // MenuFileNote: ,
          EntryFunctionNames: EntryFunctionNames,
          Language: Language,
          Memo: Memo,
          AdditionalUsers: Users,
        };

        await axios.post(
          process.env.ROOT_API + "/createTicket",
          inputData,
          config
        );

        // setTimeout(function () {
        //   const baseURL = "https://support.cmfirstgroup.com/portal/ticket/";
        //   window.location.replace(baseURL + response.data.ticketNumber);
        // }, 800);

        return true;
      } catch (exc) {
        return false;
      }
    },

    addMoreUser() {
      if(this.users.length < 5) {
        this.users.push({});
      }
    },

    deleteUser(index) {
      this.users.splice(index, 1);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/plex/Upload.vue